import React from 'react';
import Reporting from "../../../GroupReporting/Reporting";

const AutoReportSettingsTabContent = (props) => {
  return (
    <Reporting isAutoReport />
  )
}

export default AutoReportSettingsTabContent;